module.exports = __webpack_public_path__ + "img/Group 1.8b02a6a3.svg";